// 新协议
function kkmhhybrid_H5PayToNative (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "h5_pay_to_native",
    },
    param: {
      orderData: opt.orderData || '-1'
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

// 旧协议
function kkhybrid_H5PayToNative (opt) {
  hybrid({
    hybridParam: {
        schema: "kkhybrid",
        tagname: "h5PayToNative",
    },
    param: {
      todata: {
        orderData: opt.orderData || '-1'
      }
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

/**
 * 短信支付支持使用H5 中间页跳转充值中心协议<br>
 * kkmhhybrid://h5_pay_to_native（新），wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=294750168}<br>
 * kkhybrid://h5PayToNative（旧），wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=19890711}<br>
 * @param {Object} opt 参数对象
 * @param {String} opt.orderData 交易完成后的 交易信息(result_code 默认-1 string类型)
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function h5_pay_to_native (opt, criticalAppVersion) {
  // 调用新协议
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion);          //新老协议无问题可正常调用。（临界版本为全局版本号）
  if(allow) {
    // 调用新协议
    kkmhhybrid_H5PayToNative(opt);
  } else {
    // 调用旧协议
    kkhybrid_H5PayToNative(opt);
  }
}

export default h5_pay_to_native;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/h5_pay_to_native/index.js